export default function Hero() {
  return (
    <section className="relative overflow-hidden" id="top">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-8 px-4 pb-14 pt-12 md:px-6 md:pt-16 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-flashlight-fill text-sm"></i>
            大V爆料源聚合 · 实时追踪一线信息来源
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-950 md:text-5xl">
            全网热点一手情报，
            <br />
            <span className="text-primary-600">爆料源一站看齐</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            汇聚微博认证用户与百万粉红人发布的争议内容与圈内动向，按事件热度整理账号与话题。不用再全网翻找，锁定核心爆料人，追踪一手来源。
          </p>

          <form
            action="#feed"
            className="mt-7 flex max-w-xl flex-col gap-3 sm:flex-row"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="flex flex-1 items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-4 py-3">
              <i className="ri-search-line text-xl text-foreground-500"></i>
              <input
                type="text"
                placeholder="想追哪个圈子的爆料？"
                className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
              />
            </div>
            <a
              href="#feed"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即追踪
            </a>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="whitespace-nowrap text-foreground-400">今日热门领域：</span>
            {["文娱八卦", "明星艺人", "科技数码", "体娱赛场"].map((t) => (
              <a
                key={t}
                href="#bloggers"
                className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1 font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                #{t}
              </a>
            ))}
          </div>
        </div>

        <div className="relative hidden lg:block">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20collage%20of%20breaking%20news%20and%20social%20media%20buzz%2C%20warm%20crimson%20and%20amber%20accents%2C%20magazine%20cover%20mood%2C%20abstract%20headlines%20and%20notification%20icons%20floating%2C%20premium%20creative%20composition&width=1000&height=820&seq=hero-buzz-2026&orientation=portrait"
              alt="全网热点情报与社交平台爆料话题聚合图"
              className="h-full w-full object-cover"
              width={1000}
              height={820}
            />
          </div>
          <div className="absolute -bottom-4 -left-5 flex items-center gap-3 rounded-xl border border-background-200/70 bg-background-50 px-4 py-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-flashlight-fill text-xl"></i>
            </span>
            <div>
              <p className="text-sm font-bold text-foreground-950">实时更新中</p>
              <p className="text-xs text-foreground-500">今日已聚合 1,286 条话题动态</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-y border-background-200/70 bg-background-100/70">
        <div className="mx-auto flex max-w-7xl flex-col items-stretch gap-2 px-4 py-4 sm:flex-row sm:items-center md:px-6">
          <div className="flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-foreground-800">
            <i className="ri-donut-chart-fill text-lg text-primary-600"></i>
            实时热榜 TOP 3
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-1.5 sm:flex-row sm:gap-6 sm:overflow-hidden">
            <a href="#hot" className="flex min-w-0 items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-500 text-xs font-bold text-background-50">1</span>
              <span className="truncate hover:text-primary-700">综艺常驻阵容调整引发热议</span>
            </a>
            <a href="#hot" className="flex min-w-0 items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-300 text-xs font-bold text-background-50">2</span>
              <span className="truncate hover:text-primary-700">品牌代言人更替引发评论区分化</span>
            </a>
            <a href="#hot" className="hidden items-center gap-2 whitespace-nowrap text-sm text-foreground-700 md:flex">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-accent-300 text-xs font-bold text-background-50">3</span>
              <span className="truncate hover:text-primary-700">顶流艺人海外行程被拍现身机场</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}